export default {
  // Hero
  'hero.badge': 'GBCOSPACK 소개',
  'hero.title': '화장품 용기 소싱의 새로운 기준',
  'hero.subtitle':
    '글로벌 화장품 브랜드와 검증된 제조 연합을 연결하여 소싱을 투명하고 효율적이며 신뢰할 수 있게 만드는 B2B 포털입니다.',

  // Story
  'story.label': '우리의 이야기',
  'story.title': '브랜드와 공장을 잇기 위해 시작했습니다',
  'story.p1':
    'GBCOSPACK은 화장품 업계의 실제 문제를 해결하기 위해 설립되었습니다. 해외 공장에서 용기를 소싱하는 과정은 불투명하고 파편화되어 있으며 위험했습니다. 브랜드는 공급업체를 검증하거나 가격을 비교하거나 마감이 실제로 어떻게 보일지 예측하는 데 어려움을 겪었습니다.',
  'story.p2':
    '우리는 대규모·고자동화 공장들의 제조 연합을 구성하고, 그들의 제품 데이터를 하나의 검색 가능한 플랫폼으로 표준화했습니다. 이제 한 곳에서 둘러보고, 비교하고, AI로 후가공을 미리 보고, 투명한 견적을 요청할 수 있습니다.',
  'story.p3':
    '오늘날 우리는 50개국 이상의 화장품 브랜드, OEM/ODM 기업, 유통사에 서비스를 제공하며, 그들이 더 빠르고 훨씬 적은 위험으로 제품을 출시할 수 있도록 돕고 있습니다.',

  // Mission
  'mission.label': '우리가 존재하는 이유',
  'mission.title': '미션 & 비전',
  'mission.subtitle':
    '우리가 만드는 모든 것과 영입하는 모든 파트너를 이끄는 세 가지 원칙입니다.',
  'mission.m1.title': '우리의 미션',
  'mission.m1.desc':
    '브랜드를 검증된 제조 연합과 직접 연결하여 화장품 용기 소싱을 투명하고 효율적이며 신뢰할 수 있게 만듭니다.',
  'mission.m2.title': '우리의 비전',
  'mission.m2.desc':
    '모든 브랜드가 완전한 확신을 가지고 소싱할 수 있는, 세계에서 가장 신뢰받는 화장품 용기 목적지가 되는 것입니다.',
  'mission.m3.title': '우리의 약속',
  'mission.m3.desc':
    '모든 공급업체는 감사를 거치고, 모든 가격은 투명하며, 모든 주문은 샘플부터 선적까지 다단계 품질관리로 뒷받침됩니다.',

  // Values
  'values.label': '핵심 가치',
  'values.title': '우리가 지향하는 것',
  'values.subtitle':
    '이 가치들이 공급업체 검증, 가격 구조, 그리고 모든 고객 지원의 방식에 영향을 미칩니다.',
  'values.v1.title': '투명성',
  'values.v1.desc':
    '숨겨진 비용 없이, 쉬운 비교를 위한 전체 비용 내역과 표준화된 사양 시트를 제공합니다.',
  'values.v2.title': '품질 우선',
  'values.v2.desc':
    '공장 및 선적 전 다단계 품질관리와 모든 배치에 대한 완전한 이력 추적.',
  'values.v3.title': '신뢰성',
  'values.v3.desc':
    '주문마다 믿고 맡길 수 있는 안정적인 자동화 대량 생산.',
  'values.v4.title': '혁신',
  'values.v4.desc':
    'AI 후가공 미리보기와 이미지 검색으로 탐색을 그 어느 때보다 빠르게.',
  'values.v5.title': '글로벌 파트너십',
  'values.v5.desc':
    '50개국 이상의 브랜드를 위한 도어투도어 물류와 현지 지원.',
  'values.v6.title': '지속가능성',
  'values.v6.desc':
    '더 친환경적인 공급망을 위한 에코 포장 옵션과 책임 있는 소싱.',

  // Stats
  'stats.label': '숫자로 보기',
  'stats.title': '검증된 규모',
  'stats.subtitle': '수십 년간의 제조와 글로벌 무역으로 쌓아온 실적입니다.',
  'stats.s1.value': '20+',
  'stats.s1.label': '제조 경력 연수',
  'stats.s2.value': '1,000+',
  'stats.s2.label': '검증된 공급업체',
  'stats.s3.value': '50,000+',
  'stats.s3.label': '제품 SKU',
  'stats.s4.value': '50+',
  'stats.s4.label': '서비스 국가',

  // Milestones
  'milestones.label': '우리의 여정',
  'milestones.title': '우리를 만든 이정표',
  'milestones.subtitle': '하나의 공장에서 글로벌 제조 연합으로.',
  'milestones.m1.title': '첫 공장 설립',
  'milestones.m1.desc': 'CosmePack Manufacturing Group이 통합 화장품 용기 생산을 시작합니다.',
  'milestones.m2.title': '유리 용기 전문화',
  'milestones.m2.desc': 'Cristallo Glassworks가 고투명 유리 용기 라인을 가동합니다.',
  'milestones.m3.title': '튜브·플라스틱 확장',
  'milestones.m3.desc': 'FlexoTech와 PolyForm이 합류하며 라미네이트 튜브와 PET/PP 병을 연합에 추가합니다.',
  'milestones.m4.title': '글로벌 포털 론칭',
  'milestones.m4.desc': 'GBCOSPACK이 전 세계 브랜드를 위한 통합 B2B 소싱 플랫폼으로 문을 엽니다.',
  'milestones.m5.title': 'AI 미리보기·이미지 검색',
  'milestones.m5.desc': 'AI 후가공 미리보기와 유사 이미지 검색으로 탐색이 즉각적으로 바뀝니다.',
  'milestones.m6.title': '50개국 이상 서비스',
  'milestones.m6.desc': '연합은 이제 5개 대륙의 화장품 브랜드에 용기를 공급합니다.',

  // CTA
  'cta.label': '함께 일하기',
  'cta.title': '다음 제품을 함께 만들어 보세요',
  'cta.subtitle':
    '기성 용기든 완전 맞춤형 디자인이든, 우리 팀이 안내할 준비가 되어 있습니다.',
  'cta.quote': '견적 요청',
  'cta.contact': '팀에 문의하기',
  'cta.browse': '제품 둘러보기',
};